
<template>
    <div class="header">
        <div class="top">
            <div class="section">
                <template v-if="env === 'prod'">
                  <a href="https://app.fexspace.com">
                    <img src="@/assets/logo-bbb-small.png">
                  </a>
                </template>
                <template v-if="env !== 'prod'">
                  <router-link to="/">
                    <img src="@/assets/logo-bbb-small.png">
                  </router-link>
                </template>
            </div>
            <div class="search">
              <template v-if="env === 'local'">
                <ul class="url">
                  <li>
                    <a :href="protocol+'//'+host+':9009'">Dashboard</a>
                  </li>
                  <li class="active">
                    <a :href="protocol+'//'+host+':7080'">Drive</a>
                  </li>
                  <li>
                    <a :href="protocol+'//'+host+':3002/collaboration/projects'">Projects</a>
                  </li>
                  <li>
                    <a :href="protocol+'//'+host+':3002/tasks-board'">
                      <!--<svg style="width:16px;height:16px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z" />
                      </svg>&nbsp;-->
                      Tasks
                    </a>
                  </li>
                  <li>
                    <a :href="protocol+'//'+host+':3002/crm'">
                      CRM
                    </a>
                  </li>
                  <!--<li v-if="$store.getters.USER_PLAN != 1">
                    <a :href="protocol+'//'+host+':9009/contacts'">Contacts</a>
                  </li>-->
                  <li>
                    <a :href="protocol+'//'+host+':9009/calendar/month'">Schedules</a>
                  </li>
                  <li>
                    <a :href="protocol+'//'+host+':9009/m/meetings'">Meeting</a>
                  </li>
                  <template v-if="$store.getters.ACCT_TYPE == 2">
                    <li>
                      <a :href="protocol+'//'+host+':9009/explore'">Feed</a>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <a :href="protocol+'//'+host+':9009/explore'">Community</a>
                    </li>
                  </template>
                  <li class="min-link">
                    <a @click="drop_min">
                      <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z" />
                      </svg>
                    </a>
                    <ul class="drop-under" v-if="show_min" v-on-clickaway="hide">
                      <li>
                        <a :href="protocol+'//'+host+':9009/m/chats'">
                          <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                              <path fill="currentColor" d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" />
                          </svg>
                          <span>Conversations</span>
                        </a>
                      </li>
                      <li>
                        <a :href="protocol+'//'+host+':3002/teams'">
                          <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                          </svg>&nbsp;
                          <span>Teams</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </template>
              <template v-if="env === 'prod'">
                <ul class="url">
                  <li>
                    <a :href="DASHBOARD">Dashboard</a>
                  </li>
                  <li class="active">
                    <a :href="DRIVE">Drive</a>
                  </li>
                  <li>
                    <a :href="PROJECTS">Projects</a>
                  </li>
                  <li>
                    <a :href="TASKS">
                      <!--<svg style="width:16px;height:16px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z" />
                      </svg>&nbsp;-->
                      Task
                    </a>
                  </li>
                  <li>
                    <a :href="CRM">
                      CRM
                    </a>
                  </li>
                  <!--<li v-if="$store.getters.USER_PLAN != 1">
                    <a href="https://app.fexspace.com/contacts">Contacts</a>
                  </li>-->
                  <li>
                    <a :href="CALENDAR">Schedules</a>
                  </li>
                  <li>
                    <a :href="MEETING">Meeting</a>
                  </li>
                  <template v-if="$store.getters.ACCT_TYPE == 2">
                    <li>
                      <a :href="EXPLORE">Feed</a>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <a :href="EXPLORE">Community</a>
                    </li>
                  </template>
                  <li class="min-link">
                    <a @click="drop_min">
                      <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z" />
                      </svg>
                    </a>
                    <ul class="drop-under" v-if="show_min" v-on-clickaway="hide">
                      <li>
                        <a :href="MESSAGE">
                          <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M20,20H7A2,2 0 0,1 5,18V8.94L2.23,5.64C2.09,5.47 2,5.24 2,5A1,1 0 0,1 3,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M8.5,7A0.5,0.5 0 0,0 8,7.5V8.5A0.5,0.5 0 0,0 8.5,9H18.5A0.5,0.5 0 0,0 19,8.5V7.5A0.5,0.5 0 0,0 18.5,7H8.5M8.5,11A0.5,0.5 0 0,0 8,11.5V12.5A0.5,0.5 0 0,0 8.5,13H18.5A0.5,0.5 0 0,0 19,12.5V11.5A0.5,0.5 0 0,0 18.5,11H8.5M8.5,15A0.5,0.5 0 0,0 8,15.5V16.5A0.5,0.5 0 0,0 8.5,17H13.5A0.5,0.5 0 0,0 14,16.5V15.5A0.5,0.5 0 0,0 13.5,15H8.5Z" />
                          </svg>
                          <span>Conversations</span>
                        </a>
                      </li>
                      <li>
                        <a :href="TEAMS">
                          <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                          </svg>&nbsp;
                          <span>Team</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </template>
                <div class="input-box">
                    <i class="fa fa-search"></i>
                    <input type="text" @keypress="typeterm" placeholder="Search Drive" v-model="type_term" @focus="showlistdown" />
                    <i class="fa fa-caret-down" @click="openadvance"></i>
                </div>
                <div class="listdown" v-if="listdown" @click="closelistdown" v-click-outside="hide">
                    <ul v-click-outside="hide">
                        <li data-text="Word Document"><img src="@/assets/icons/icon/Doc.svg" width="22px" height="22px" /> &nbsp;&nbsp;Word Document</li>
                        <li data-text="Sheets Document"><img src="@/assets/icons/icon/XLS.svg" width="22px" height="22px" /> &nbsp;&nbsp;Sheets Document</li>
                        <li data-text="Presentation Document"><img src="@/assets/icons/icon/PPT.svg" width="22px" height="22px" /> &nbsp;&nbsp;Presentation Document</li>
                        <li data-text="Images"><img src="@/assets/icons/icon/image.svg" width="22px" height="22px" /> &nbsp;&nbsp;Images</li>
                        <li data-text="Videos"><img src="@/assets/icons/icon/video.svg" width="22px" height="22px" /> &nbsp;&nbsp;Videos</li>
                        <li data-text="Audios"><img src="@/assets/icons/icon/Mp3.svg" width="22px" height="22px" /> &nbsp;&nbsp;Audios</li>
                        <li data-text="Folders"><img src="@/assets/icons/folder/General.svg" width="22px" height="22px" style="margin-left:3px" /> &nbsp;&nbsp;Folders</li>
                        <li data-text="Zipped"><img src="@/assets/icons/icon/Rar.svg" width="22px" height="22px" /> &nbsp;&nbsp;Compressed File</li>
                        <li data-text="Text"><img src="@/assets/icons/icon/TXT.svg" width="22px" height="22px" /> &nbsp;&nbsp;Text File</li>
                        <li data-text="PDF"><img src="@/assets/icons/icon/PDF.svg" width="22px" height="22px" /> &nbsp;&nbsp;PDF</li>
                    </ul>
                </div>
                <div class="advance" v-if="advance" @click="closemenudown" v-click-outside="hide">
                    <h3>Search filter</h3>
                    <ul>
                        <li>
                            <div>
                              Type
                            </div>
                            <div class="mix">
                                <span class="tbox" @click="showtype">{{ filetype }}
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="!doctype">
                                        <path fill="#999" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                    </svg>
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="doctype">
                                        <path fill="#999" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
                                    </svg>
                                </span>
                                <ul class="menu" v-if="doctype" v-click-outside="hide" @click="select_filetype">
                                    <li data-text="Word Document"><img src="@/assets/icons/icon/Doc.svg" width="22px" height="22px" /> &nbsp;&nbsp;Word Document</li>
                                    <li data-text="Sheets Document"><img src="@/assets/icons/icon/XLS.svg" width="22px" height="22px" /> &nbsp;&nbsp;Sheets Document</li>
                                    <li data-text="Presentation Document"><img src="@/assets/icons/icon/PPT.svg" width="22px" height="22px" /> &nbsp;&nbsp;Presentation Document</li>
                                    <li data-text="Images"><img src="@/assets/icons/icon/image.svg" width="22px" height="22px" /> &nbsp;&nbsp;Images</li>
                                    <li data-text="Videos"><img src="@/assets/icons/icon/video.svg" width="22px" height="22px" /> &nbsp;&nbsp;Videos</li>
                                    <li data-text="Audios"><img src="@/assets/icons/icon/Mp3.svg" width="22px" height="22px" /> &nbsp;&nbsp;Audios</li>
                                    <li data-text="Folders"><img src="@/assets/icons/folder/General.svg" width="22px" height="22px" style="margin-left:3px" /> &nbsp;&nbsp;Folders</li>
                                    <li data-text="Zipped"><img src="@/assets/icons/icon/Rar.svg" width="22px" height="22px" /> &nbsp;&nbsp;Compressed File</li>
                                    <li data-text="Text"><img src="@/assets/icons/icon/TXT.svg" width="22px" height="22px" /> &nbsp;&nbsp;Text File</li>
                                    <li data-text="PDF"><img src="@/assets/icons/icon/PDF.svg" width="22px" height="22px" /> &nbsp;&nbsp;PDF</li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <div>
                                Owner
                            </div>
                            <div class="mix">
                                <span class="tbox" @click="showowner">{{ fileowner }}
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="!file_owner">
                                        <path fill="#999" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                    </svg>
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="file_owner">
                                        <path fill="#999" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
                                    </svg>
                                </span>
                                <ul class="menu" v-if="file_owner" v-click-outside="hide" @click="select_fileowner">
                                    <li data-text="Owned by me">
                                      <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                        <path fill="#999" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                                      </svg>
                                      &nbsp;&nbsp;Owned by me
                                    </li>
                                    <li data-text="Shared with me">
                                      <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                        <path fill="#999" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                                      </svg>
                                      &nbsp;&nbsp;Shared with me
                                    </li>
                                    <li data-text="Shared by me">
                                          <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                              <path fill="#999" d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                                          </svg>
                                          &nbsp;&nbsp;Shared by me
                                    </li>
                                    <template v-if="filelocation == 'Group Folder' || filelocation == 'Public' || filelocation == 'Any'">
                                      <li data-text="Owned by others">
                                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                            <path fill="#999" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                                        </svg>
                                        &nbsp;&nbsp;Owned by others
                                      </li>
                                    </template>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <div>
                                File name
                            </div>
                            <div class="mix">
                                <input type="text" v-model="filename" placeholder="Enter name of file" class="suga"/>
                            </div>
                        </li>
                        <li>
                            <div>
                                Date Modified
                            </div>
                            <div class="mix">
                                <p>
                                    <span class="tbox" @click="showdate">{{ filedate }}
                                        <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="!file_owner">
                                            <path fill="#999" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                        </svg>
                                        <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="file_owner">
                                            <path fill="#999" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
                                        </svg>
                                    </span>
                                    <ul class="menu" v-if="select_date" v-click-outside="hide" @click="selectdate">
                                        <li data-text="Today"> &nbsp;&nbsp;Today</li>
                                        <li data-text="Yesterday"> &nbsp;&nbsp;Yesterday</li>
                                        <li data-text="Last 7 Days"> &nbsp;&nbsp;Last 7 Days</li>
                                        <li data-text="Last 30 Days"> &nbsp;&nbsp;Last 30 Days</li>
                                        <li data-text="Last 90 Days"> &nbsp;&nbsp;Last 90 Days</li>
                                        <li data-text="Custom Date"> &nbsp;&nbsp;Custom Date</li>
                                    </ul>
                                </p>
                                <p class="custom-date" v-if="filedate === 'Custom Date'" style="margin-bottom:0;">
                                    <span>
                                        <date-picker v-model="start_date" :lang="lang"></date-picker>
                                    </span>
                                    <span>
                                        <date-picker v-model="end_date" :lang="lang"></date-picker>
                                    </span>
                                </p>
                            </div>
                        </li>
                        <li v-if="fileowner === 'Owned by me' || fileowner === 'Owned by others' || fileowner === 'Select owner of file'">
                            <div>
                                Search Location
                            </div>
                            <div class="mix">
                                <span class="tbox" @click="selectfilelocation">{{ filelocation }}
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="!file_owner">
                                        <path fill="#999" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                    </svg>
                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="file_owner">
                                        <path fill="#999" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
                                    </svg>
                                </span>
                                <ul class="menu" v-if="file_location" v-click-outside="hide" @click="select_filelocation">
                                    <li data-text="Any" style="padding-left: 10px;">
                                        <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                            <path fill="#999" d="M10,17L6.5,13.5L7.91,12.08L10,14.17L15.18,9L16.59,10.41M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.03Z" />
                                        </svg>
                                        &nbsp;&nbsp;Any
                                    </li>
                                    <li data-text="My Space">
                                        <svg style="width:18px;height:18px" viewBox="0 0 16 16">
                                            <path fill="#999" d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z" />
                                        </svg>
                                        &nbsp;&nbsp;My Space
                                    </li>
                                    <li data-text="Group Folder">
                                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                            <path fill="#999" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                                        </svg>
                                         &nbsp;&nbsp;Group Folder
                                    </li>
                                    <li data-text="Project Folder">
                                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                            <path fill="#999" d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                                        </svg>
                                         &nbsp;&nbsp;Project Folder
                                    </li>
                                    <li data-text="Public">
                                        <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                            <path fill="#999" d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                        </svg>
                                         &nbsp;&nbsp;Public
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li style="margin-bottom: .4em;margin-top:2em;">
                            <span class="search-btn" @click="makerequest">Search</span>&nbsp;&nbsp;<span class="reset-btn" @click="resetsearch">Reset</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section">
                <div class="menu">
                    <div class="create-new">
                        <div v-if="showNewButton" class="new-button" @click="show_create_dropdown">
                          <span class="fa fa-plus-circle"></span> New
                        </div>
                        <div class="dropdown" v-if="create_dropdown" v-on-clickaway="hide" @click="close_drop">
                            <template v-if="$store.getters.canCreateFiles">
                                <ul>
                                  <li @click="create_doc('word')"><i class="fa fa-file-word"></i> &nbsp;Docs</li>
                                  <li @click="create_doc('sheets')"><i class="fa fa-file-excel"></i> &nbsp;Sheets</li>
                                  <li @click="create_doc('powerpoint')"><i class="fa fa-file-powerpoint"></i> &nbsp;Presentation</li>
                                  <li @click="create_doc('folder')"><i class="fa fa-folder"></i> &nbsp;Folder</li>
                                  <li class="line-div"></li>
                                  <li @click="trigger"><i class="fa fa-cloud-upload-alt"></i> &nbsp;Upload File</li>
                                </ul>
                            </template>
                            <template v-if="$store.getters.canCreateGroupFolder">
                                <ul>
                                  <li @click="create_doc('group-folder')"><i class="fa fa-folder"></i> &nbsp;Create Group Folder</li>
                                </ul>
                            </template>
                            <template v-if="$store.getters.canCreateFileInGroup">
                                <ul>
                                  <li @click="create_doc('word')"><i class="fa fa-file-word"></i> &nbsp;Docs</li>
                                  <li @click="create_doc('sheets')"><i class="fa fa-file-excel"></i> &nbsp;Sheets</li>
                                  <li @click="create_doc('powerpoint')"><i class="fa fa-file-powerpoint"></i> &nbsp;Presentation</li>
                                  <li @click="create_doc('folder')"><i class="fa fa-folder"></i> &nbsp;Folder</li>
                                  <li class="line-div"></li>
                                  <li @click="trigger"><i class="fa fa-cloud-upload-alt"></i> &nbsp;Upload File</li>
                                </ul>
                            </template>
                        </div>
                    </div>
                    <input type="file" id="file" ref="file" @change="upload" multiple style="display:none;">
                    <div class="note custom-tooltip-container" @click="show_note">
                      <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                          <path fill="#fff" d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" />
                      </svg>
                      <span class="custom-tooltiptext" style="left: -15px">
                        Note
                      </span>
                    </div>
                    <div class="chat custom-tooltip-container" @click="show_chat">
                        <img src="@/assets/icons8-chat-24--1.png" /><span class="notificattion-count" v-if="$store.getters.TOTAL_CHAT">{{ $store.getters.TOTAL_CHAT }}</span>
                        <span class="custom-tooltiptext" style="left: -30px">
                          Messenger
                        </span>
                    </div>
                    <div class="bell custom-tooltip-container" @click="show_notification">
                        <img src="@/assets/icons8-bell-24.png" /><span class="notificattion-count" v-if="$store.getters.TOTAL_NOTIFICATION">{{ $store.getters.TOTAL_NOTIFICATION }}</span>
                        <span class="custom-tooltiptext" style="left: -30px">
                          Notification
                        </span>
                    </div>
                </div>
                <div class="profile">
                    <div>
                      |
                    </div>
                    <div class="profile-pic" title="Update profile picture" @click="user_dropdown">
                        <span class="default-pic" v-if="!$store.getters.PHOTO">{{ getName($store.getters.FIRSTNAME) }}</span>
                        <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
                    </div>
                    <ul class="userdropdown" v-if="userdropdown" v-on-clickaway="hide">
                      <li class="pic-house">
                        <template v-if="!$store.getters.PHOTO">
                          <span class="default-pic">{{ getName($store.getters.FIRSTNAME) }}</span>
                        </template>
                        <template v-if="$store.getters.PHOTO">
                          <span class="trigger_pic_self">
                            <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
                          </span>
                        </template>
                        &nbsp;&nbsp;
                        <span>{{ $store.getters.FIRSTNAME + ' ' + $store.getters.LASTNAME }}</span>
                      </li>
                      <li class="d-flex flex-column" v-if="$store.getters.ACCT_TYPE == 2">
                        <strong style="font-size: 12px">Organisation:</strong>
                        <span style="font-size: 16px">{{ $store.getters.COMPANY }}</span>
                      </li>
                      <!--<li>
                        <template v-if="this.$store.getters.PHONE.trim().length > 0">
                          <span>{{ $store.getters.PHONE }}</span>
                        </template>
                        <template v-if="this.$store.getters.PHONE.trim().length == 0">
                          <span>None</span>
                        </template>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                          </svg>
                        </i>
                      </li>-->
                      <li>
                        <span v-if="$store.getters.EMAIL">{{ $store.getters.EMAIL }}</span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
                          </svg>
                        </i>
                      </li>
                      <!--<li>
                        <template v-if="$store.getters.COUNTRY">
                          <span>{{ $store.getters.COUNTRY }}</span>
                        </template>
                        <template v-if="!$store.getters.COUNTRY">
                          <span>None</span>
                        </template>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                              <path fill="#888" d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                        </i>
                      </li>-->
                      <!--<li>
                        <span
                          v-if="$store.getters.DATE_CREATED"
                        >{{ format_date($store.getters.DATE_CREATED) }}</span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M7,12H9V14H7V12M21,6V20A2,2 0 0,1 19,22H5C3.89,22 3,21.1 3,20V6A2,2 0 0,1 5,4H6V2H8V4H16V2H18V4H19A2,2 0 0,1 21,6M5,8H19V6H5V8M19,20V10H5V20H19M15,14V12H17V14H15M11,14V12H13V14H11M7,16H9V18H7V16M15,18V16H17V18H15M11,18V16H13V18H11Z" />
                          </svg>
                        </i>
                      </li>-->
                      <li class="collapsable" @click="show_subdown">
                        <p>
                          <span>Settings</span>
                          <i>
                            <svg v-if="sub_dropdown" style="width:20px;height:20px" viewBox="0 0 24 24">
                              <path fill="#888" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                            </svg>
                            <svg v-if="!sub_dropdown" style="width:20px;height:20px" viewBox="0 0 24 24">
                              <path fill="#888" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                            </svg>
                          </i>
                        </p>
                        <ul v-if="sub_dropdown">
                          <li v-if="$store.getters.ISADMIN">
                            <router-link to="/create-public-folder">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>Create Public Folder</span>
                            </router-link>
                          </li>
                          <li v-if="$store.getters.ISADMIN">
                            <router-link to="/create-department">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>All Department</span>
                            </router-link>
                          </li>
                          <li v-if="$store.getters.ISADMIN">
                            <router-link to="/group-folder-request">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>Group Folder Request</span>
                            </router-link>
                          </li>
                          <!--<li v-if="$store.getters.ISADMIN"><router-link to="folder-access-control">Folder Access Control</router-link></li>-->
                          <li v-if="$store.getters.ISADMIN">
                            <router-link to="/all-users">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              All Users
                            </router-link>
                          </li>
                          <li v-if="$store.getters.ISADMIN">
                            <router-link to="/payments-billing">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              Payments & Billing
                            </router-link>
                          </li>
                          <template v-if="$store.getters.ACCT_TYPE == 1">
                            <li>
                              <router-link to="/payments-billing">
                                <i>
                                  <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                    <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                  </svg>
                                </i>
                                <span>Payments & Billing</span>
                              </router-link>
                            </li>
                          </template>
                          <li v-if="$store.getters.ACCT_TYPE == 2 && !$store.getters.ISADMIN">
                            <router-link to="/request-more-storage">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>Request More Storage</span>
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/usage-quota">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>Usage Quota</span>
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/update-profile">
                              <i>
                                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                  <path fill="#666" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                </svg>
                              </i>
                              <span>Update Profile</span>
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <li v-if="$store.getters.ISADMIN" style="display:block;">
                        <router-link to="/create-page" style="display:flex;justify-content:space-between;">
                          <span>Create a Page</span>
                          <i>
                            <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                              <path fill="#888" d="M19 1L14 6V17L19 12.5V1M21 5V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5M10 18.41C8.75 18.09 7.5 18 6.5 18C5.44 18 4.18 18.19 3 18.5V7.13C3.91 6.73 5.14 6.5 6.5 6.5C7.86 6.5 9.09 6.73 10 7.13V18.41Z" />
                            </svg>
                          </i>
                        </router-link>
                      </li>
                      <li style="cursor: pointer" @click="invite">
                        <span>
                          Send invite link
                        </span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z" />
                          </svg>
                        </i>
                      </li>
                      <li style="cursor: pointer" @click="copy_invite_link">
                        <span>
                          Referral link
                        </span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
                          </svg>
                        </i>
                        <input type="hidden" id="referral_link" :value="$store.getters.REFERRAL_LINK" />
                      </li>
                      <li @click="download" style="cursor:pointer">
                        <span>
                          Download File Syncing App
                        </span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                          </svg>
                        </i>
                      </li>
                      <li style="cursor:pointer" v-if="$store.getters.USER_PLAN == 1">
                        <router-link to="/payments-billing" class="upgrade-btn">
                          Upgrade to Pro
                        </router-link>
                      </li>
                      <li class="logout" @click="logout">
                        <span>Logout</span>
                        <i>
                          <svg style="width:19px;height:19px" viewBox="0 0 24 24">
                            <path fill="#888" d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
                          </svg>
                        </i>
                      </li>
                    </ul>
                </div>
            </div>
        </div><!-- end of top -->
        <div class="bottom">
            <div class="section-right">
                <div class="file-actions">
                    <template v-if="$store.getters.GET_CURRENT_DIRECTORY != 'Trash' && $store.getters.GET_CURRENT_DIRECTORY !== 'Shared Files' && $store.getters.GET_CURRENT_DIRECTORY !== 'Shared With Me'">
                        <div class="share-file" @click="sharefile" v-if="$store.getters.FILE_ACTION">
                            <span class="fa fa-share-square"></span> &nbsp;Share File
                        </div>
                        <div class="delete-file" @click="deletefile" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete File
                        </div>
                        <div class="delete-file" @click="deletefiles" v-if="$store.getters.FILE_ACTION > 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete
                        </div>
                        <div class="move-folder" @click="moveto" v-if="$store.getters.FILE_ACTION">
                            <span class="folder-move">
                                <!--<svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" />
                                </svg>-->

                                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" />
</svg>
                            </span> &nbsp;Move to
                        </div>
                        <div class="copy-file" @click="copyto" v-if="$store.getters.FILE_ACTION">
                            <span class="vector-arrange-below">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M20,22C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C16.33,7 12.67,7 9,7C7.89,7 7,7.89 7,9C7,12.67 7,16.33 7,20C7,21.11 7.89,22 9,22H20M20,20H9V9H20V20M5,16V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5Z" />
                                </svg>
                            </span> &nbsp;Copy to
                        </div>
                        <div class="rename-file" @click="renamefile" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="vector-arrange-below">
                                <svg style="width:15px;height:15px" viewBox="0 0 24 24">
                                    <path d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z" />
                                </svg>
                            </span> &nbsp;Rename
                        </div>
                        <div class="compress-file" @click="compressfile" v-if="$store.getters.FILE_ACTION">
                            <span class="vector-arrange-below">
                                <i class="fa fa-file-archive"></i>
                            </span> &nbsp;Compress
                        </div>
                        <div class="favourite-file" @click="addtofavourite" v-if="$store.getters.FILE_ACTION">
                            <span class="vector-arrange-below">
                                <i class="fa fa-star"></i>
                            </span> &nbsp;Add to favourite
                        </div>
                        <div class="add-comment-file" @click="addcomment" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="vector-arrange-below">
                                <i class="fa fa-comment-alt"></i>
                            </span> &nbsp;Add Comment
                        </div>
                    </template>
                    <template v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Trash'">
                        <div class="delete-file" @click="deletefile" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete File
                        </div>
                        <div class="delete-file" @click="deleteall" v-if="$store.getters.FILE_ACTION > 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete
                        </div>
                        <div class="delete-file" @click="restorefile" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="trash">
                                <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                    <path d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z" />
                                </svg>
                            </span> &nbsp;Restore File
                        </div>
                        <div class="delete-file" @click="restore" v-if="$store.getters.FILE_ACTION > 1">
                            <span class="trash">
                                <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                    <path d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z" />
                                </svg>
                            </span> &nbsp;Restore
                        </div>
                    </template>
                    <template v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Shared Files'">
                        <div class="delete-file" @click="deletefile" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete File
                        </div>
                        <div class="delete-file" @click="deleteall" v-if="$store.getters.FILE_ACTION > 1">
                            <span class="trash">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                    <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                                </svg>
                            </span> &nbsp;Delete
                        </div>
                        <div class="favourite-file" @click="addtofavourite" v-if="$store.getters.FILE_ACTION">
                            <span class="vector-arrange-below">
                                <i class="fa fa-star"></i>
                            </span> &nbsp;Add to favourite
                        </div>
                        <div class="add-comment-file" @click="addcomment" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="vector-arrange-below">
                                <i class="fa fa-comment-alt"></i>
                            </span> &nbsp;Add Comment
                        </div>
                    </template>
                    <template v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Shared With Me'">
                        <div class="favourite-file" @click="addtofavourite" v-if="$store.getters.FILE_ACTION">
                            <span class="vector-arrange-below">
                                <i class="fa fa-star"></i>
                            </span> &nbsp;Add to favourite
                        </div>
                        <div class="add-comment-file" @click="addcomment" v-if="$store.getters.FILE_ACTION == 1">
                            <span class="vector-arrange-below">
                                <i class="fa fa-comment-alt"></i>
                            </span> &nbsp;Add Comment
                        </div>
                    </template>
                </div>
                <div class="file-order">
                    <div class="sort-order">
                        <div class="p-cursor" @click="show_sort_order">
                            <img src="@/assets/icons8-ascending-sorting-15.png" /> Sort Files
                        </div>
                        <div class="sort-options" v-if="sort_order" v-on-clickaway="hide" @click="close_drop">
                            <ul>
                                <li @click="sort_type_action('dir')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_TYPE == 'dir'" /></span>Name</li>
                                <li @click="sort_type_action('size')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_TYPE == 'size'" /></span>Size</li>
                                <li @click="sort_type_action('is_dir')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_TYPE == 'is_dir'" /></span>Type</li>
                                <li @click="sort_type_action('updatedAt')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_TYPE == 'updatedAt'" /></span>Date</li>
                            </ul>
                            <ul>
                                <li @click="sort_order_action('asc')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_ORDER == 'asc'"/></span>Ascending Order</li>
                                <li @click="sort_order_action('desc')"><span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_ORDER == 'desc'" /></span>Descending Order</li>
                            </ul>
                        </div>
                    </div>
                    <div class="file-view-options">
                        <div>
                            <div class="file-view-options" @click="show_view_options">
                                <img src="@/assets/icons8-align-left-15.png" /> File View Options
                            </div>
                            <div class="view-options" v-if="view_options" v-on-clickaway="hide">
                                <ul @click="close_drop">
                                    <li @click="view_type_action('grid')">
                                        <span class="mark">
                                            <img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.VIEW_TYPE == 'grid'" />
                                        </span>
                                        <span>
                                            <i class="fa fa-th"></i>
                                            Grid View
                                        </span>
                                    </li>
                                    <li @click="view_type_action('list')">
                                        <span class="mark">
                                            <img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.VIEW_TYPE == 'list'" />
                                        </span>
                                        <span>
                                            <i class="fa fa-list"></i>
                                            List View
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.mark {
  background: none;
}
.mx-input {
  width: 68% !important;
  padding: 0 !important;
}
.default-pic {
  background: #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #71809a;
  width: 40px;
  height: 40px;
  font-size: 1.125rem;
  font-weight: bold;
}
.custom-tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip-container .custom-tooltiptext {
  visibility: hidden;
  background-color: #596a73;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 2px 5px;
  position: absolute;
  z-index: 1;
  top: 25px;
  opacity: 0;
  transition: opacity 0.5s, padding 0.3s;
  font-size: 12px;
}

.custom-tooltip-container:hover .custom-tooltiptext {
  visibility: visible;
  opacity: 1;
  padding: 5px 10px;
}
</style>

<script>
import ClickOutside from "vue-click-outside";
import { mapMutations } from "vuex";
import { directive as onClickaway } from "vue-clickaway";
import moment from "moment";
import DatePicker from "vue2-datepicker2";
// import Onboard from '@/components/Onboard'
import cookies from "@/services/cookies";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      id: localStorage.getItem("id"),
      file_actions: false,
      create_dropdown: false,
      sort_order: false,
      view_options: false,
      listdown: false,
      settings_dropdown: false,
      notification_dropdown: false,
      type_term: "",
      advance: false,
      doctype: false,
      file_owner: false,
      select_date: false,
      start_date: "",
      end_date: "",
      filetype: "Select file type",
      fileowner: "Owned by me",
      filedate: "Select date file was modified",
      filelocation: "My Space",
      file_location: false,
      filename: "",
      post: false,
      show_min: false,
      lang: {
        type: "en",
      },
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
      host: location.hostname,
      protocol: location.protocol,
      userdropdown: false,
      sub_dropdown: true,
      TASKS: process.env.VUE_APP_TASKS,
      CRM: process.env.VUE_APP_CRM,
      TEAMS: process.env.VUE_APP_TEAMS,
      MESSAGE: process.env.VUE_APP_MESSAGE,
      MEETING: process.env.VUE_APP_MEETING,
      CALENDAR: process.env.VUE_APP_CALENDAR,
      PROJECTS: process.env.VUE_APP_PROJECTS,
      DRIVE: process.env.VUE_APP_DRIVE,
      DASHBOARD: process.env.VUE_APP_DASHBOARD,
      EXPLORE: process.env.VUE_APP_EXPLORE,
    };
  },
  computed: {
    showNewButton() {
      return this.$store.getters.showNewButton;
    },
  },
  methods: {
    copy_invite_link() {
      let link = document.querySelector("#referral_link").value;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "referallink");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("referallink");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let that = this;

      that.$toast.open({
        message:
          '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Referral link copied to clipboard',
        type: "default",
        position: "bottom-right",
      });
    },
    hide_userdropdown() {
      this.userdropdown = false;
    },
    getName(name) {
      return name[0];
    },
    invite() {
      this.$parent.invite();
    },
    drop_min() {
      if (!this.show_min) {
        this.show_min = true;
      } else {
        this.show_min = false;
      }
    },
    show_subdown() {
      this.sub_dropdown = !this.sub_dropdown;
    },
    logout() {
      this.$parent.logout();
    },
    format_date(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    ago(time) {
      return moment(time).fromNow();
    },
    ...mapMutations([
      "SET_SORT_TYPE",
      "SET_SORT_ORDER",
      "SET_VIEW_TYPE",
      "SORT_DIRECTORY_CHILDREN",
      "TOGGLE_CHAT",
      "TOGGLE_NOTE",
      "TOGGLE_NOTIFICATION",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "SET_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_NOTIFICATION_COUNT",
      "TOGGLE_EMBED",
      "SET_PATH",
    ]),
    download() {
      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href = "https://fexspace.com/downloads/Fexspace-client-Setup.exe";
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    logincall() {
      this.$parent.logincall();
    },
    user_dropdown() {
      this.userdropdown = !this.userdropdown;
      this.sub_dropdown = false;
    },
    handleScroll(evt) {
      // console.log(evt.target.clientHeight)
      // console.log(evt.target.scrollTop)
      // console.log(evt.target.scrollHeight)

      if (
        evt.target.clientHeight + evt.target.scrollTop >=
        evt.target.scrollHeight
      ) {
        let data = {
          token: cookies.getCookie("token"),
          cur_page: this.$store.getters.NOTIFICATION.length,
        };
        this.$socket.emit("load-notification", data, function (data) {});
      }
    },
    typeterm(evt) {
      this.listdown = false;

      if (evt.keyCode === 13 || evt.which === 13) {
        let term = evt.target.value;

        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          method: "text",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
          }
        });
      }
    },
    select_fileowner(evt) {
      if (evt.target.nodeName === "LI") {
        this.fileowner = evt.target.getAttribute("data-text");
        this.file_owner = false;
      }
    },
    select_filetype(evt) {
      if (evt.target.nodeName === "LI") {
        this.filetype = evt.target.getAttribute("data-text");
        this.doctype = false;
      }
    },
    selectdate(evt) {
      if (evt.target.nodeName === "LI") {
        this.filedate = evt.target.getAttribute("data-text");
        this.select_date = false;

        if (this.filedate !== "Custom Date") {
          this.start_date = "";
          this.end_date = "";
        }
      }
    },
    selectfilelocation() {
      this.file_location = !this.file_location;
      this.file_owner = false;
      this.select_date = false;
      this.doctype = false;
    },
    select_filelocation(evt) {
      if (evt.target.nodeName === "LI") {
        this.filelocation = evt.target.getAttribute("data-text");
        this.file_location = false;
      }
    },
    showdate() {
      this.select_date = !this.select_date;
      this.file_owner = false;
      this.doctype = false;
      this.file_location = false;
    },
    showowner() {
      this.file_owner = !this.file_owner;
      this.select_date = false;
      this.doctype = false;
      this.file_location = false;
    },
    closemenudown(evt) {
      // console.log(evt.target.closet('.advance'))
      if (evt.target.className === "advance") {
        this.doctype = false;
        this.file_owner = false;
        this.select_date = false;
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-D-MM");
    },
    showtype() {
      this.doctype = !this.doctype;
      this.select_date = false;
      this.file_owner = false;
    },
    makerequest() {
      this.advance = false;

      let term = "";

      if (
        this.filetype !== "" ||
        this.fileowner !== "" ||
        this.filename !== "" ||
        this.filedate !== "" ||
        this.filelocation !== ""
      ) {
        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          type: this.filetype,
          owner: this.fileowner,
          name: this.filename,
          date: this.filedate,
          start_date: this.start_date,
          end_date: this.end_date,
          file_location: this.filelocation,
          method: "filter",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
          }
        });
      }
    },
    openadvance() {
      this.listdown = false;
      this.advance = !this.advance;
    },
    resetsearch() {
      this.filetype = "Select file type";
      this.fileowner = "Owned by me";
      this.filedate = "Select date file was modified";
      this.filelocation = "My Space";
      this.start_date = "";
      this.end_date = "";
    },
    closeadvance() {
      this.listdown = false;
      this.advance = false;
    },
    compressfile() {
      if (this.$store.getters.FILE_ACTION > 1) {
        this.$parent.promptcompressrename();
        return;
      }

      let items = Object.values(this.$store.getters.GET_FILES_INDEX);
      this.$parent.compressfile(items[0], "group");
    },
    searchfile() {
      this.$parent.searchfile();
    },
    closesearch() {
      this.$parent.closesearchfile();
    },
    closelistdown(e) {
      let term = "";
      if (e.target.nodeName === "LI" || e.target.nodeName === "I") {
        this.listdown = false;
      }

      if (e.target.nodeName === "LI") {
        this.type_term = "type:" + e.target.innerText.trim();
        term = e.target.innerText.trim();
      }

      if (e.target.nodeName === "I") {
        this.type_term = "type:" + e.target.parentNode.innerText.trim();
        term = e.target.parentNode.innerText.trim();
      }

      if (term != "") {
        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          method: "type",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
          }
        });
      }
    },
    copyto() {
      this.$parent.group_copyto();
    },
    moveto() {
      this.$parent.group_moveto();
    },
    sharefile() {
      this.$parent.sharefile(null, true);
    },
    deletefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      if (this.$store.getters.GET_CURRENT_DIRECTORY == "Trash") {
        this.$parent.trashdeleteprompt(index, id);
      } else {
        this.$parent.deletefile(index, id, "group");
      }
    },
    deleteall() {
      this.$parent.grouptrashdeleteprompt();
    },
    addtofavourite() {
      this.$parent.group_add_to_favourite();
    },
    addcomment() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      this.$parent.add_comment(name, id);
    },
    renamefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      this.$parent.renamefile(index, name, id, true);
    },
    restorefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];

      this.$parent.restorefile(index);
    },
    restore() {
      this.$parent.grouprestore();
    },
    deletefiles() {
      this.$parent.group_delete();
    },
    slideout() {
      this.UPDATE_SLIDEIN(true);
      this.UPDATE_SLIDEOUT(false);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(true);
    },
    showlistdown() {
      this.type_term = "";
      this.listdown = true;
      this.advance = false;
    },
    hidelistdown(e) {},
    show_chat() {
      this.TOGGLE_EMBED("chat");
    },
    show_note() {
      this.TOGGLE_EMBED("note");
    },
    show_notification() {
      this.TOGGLE_EMBED("notification");
    },
    sort_type_action(type) {
      this.SET_SORT_TYPE(type);
      this.SORT_DIRECTORY_CHILDREN();
    },
    sort_order_action(order) {
      this.SET_SORT_ORDER(order);
      this.SORT_DIRECTORY_CHILDREN();
    },
    view_type_action(type) {
      if (
        this.$store.getters.DIRECTORY_CHILDREN[
          this.$store.getters.GET_FILE_INDEX
        ] != undefined
      ) {
        this.$store.getters.DIRECTORY_CHILDREN[
          this.$store.getters.GET_FILE_INDEX
        ].show = false;
        this.SET_VIEW_TYPE(type);
      } else {
        this.SET_VIEW_TYPE(type);
      }
      this.$parent.set_view_type(type);
    },
    show_sort_order() {
      this.sort_order = !this.sort_order;
    },
    show_create_dropdown() {
      this.create_dropdown = !this.create_dropdown;
    },
    show_view_options() {
      this.view_options = !this.view_options;
    },
    hide() {
      this.create_dropdown = false;
      this.sort_order = false;
      this.view_options = false;
      this.listdown = false;
      this.settings_dropdown = false;
      this.notification_dropdown = false;
      this.advance = false;
      this.show_min = false;
      this.doctype = false;
      this.userdropdown = false;
      this.sub_dropdown = false;
    },
    create_doc(type) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      if (this.$store.getters.GET_CURRENT_DIRECTORY == "Trash") {
        this.$parent.cant_create(this.$store.getters.GET_CURRENT_DIRECTORY);
      } else {
        this.$parent.create(type);
      }
    },
    trigger() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      let up = document.querySelector("#file");
      up.click();
    },
    upload() {
      this.$parent.upload(this.$refs.file.files);
      this.$refs.file.value = "";
    },
    close_drop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.create_dropdown = false;
        this.sort_order = false;
        this.view_options = false;
      }
    },
    show_settings_dropdown() {
      if (this.settings_dropdown) {
        this.settings_dropdown = false;
      } else {
        this.settings_dropdown = true;
      }
    },
    show_notification_dropdown() {
      this.notification_dropdown = !this.notification_dropdown;
      let that = this;
      let ids = this.$store.getters.NOTIFICATION.filter((n) => {
        if (!n.is_checked.includes(localStorage.getItem("id"))) {
          return n.id;
        }
      });

      ids = ids.map((id) => {
        return id.id;
      });

      if (ids.length) {
        let data = {
          token: cookies.getCookie("token"),
          ids,
        };
        this.$socket.emit("update-check-notification", data, function (data) {
          if (data.data == true) {
            that.UPDATE_NOTIFICATION_COUNT(0);
          }
        });
      }
    },
  },
  mounted() {
    this.show_subdown();
    this.popupItem = this.$el;
  },
  directives: {
    onClickaway: onClickaway,
    ClickOutside,
  },
};
</script>
